import { render, staticRenderFns } from "./SupportCulturalProgram.vue?vue&type=template&id=eff8e738&"
import script from "./SupportCulturalProgram.vue?vue&type=script&lang=js&"
export * from "./SupportCulturalProgram.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports